export enum NetworkStatus {
    Offline = "offline", // user is probably offline
    Disconnecting = "disconnecting", // user is possibly offline
    Online = "online", // user is probably online
}
